$(document).ready(function () {


    // industries //

    var industries = new Swiper('.js-industries', {        
        slidesPerView: "auto",
        slidesPerView: 2,
        centeredSlides: false,        
        spaceBetween: 0,
        loop: false,
        speed: 3000,        
        autoplay: {
            delay: 40000,
            disableOnInteraction: false,
        },    
        breakpoints: {
            // 360: {
            //     slidesPerView: 1,
                
            // },

            // 375: {
            //     slidesPerView: 1,
                
            // },

            // 414: {
            //     slidesPerView: 1.5,
               
            // },

            768: {   
                slidesPerView: "auto",
                centeredSlides: true,
                slidesPerView: 1.5,
                spaceBetween: 20,
                loop: true,
                speed: 2000,        
                autoplay: {
                    delay: 1000,                   
                },
                pagination: ".swiper-pagination",
                paginationClickable: true,                
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        }

    });

    // banner card resp

    (function () {
        "use strict";
        const breakpoint = window.matchMedia("(min-width:40.25em)");

        // keep track of swiper instances to destroy later
        let mySwiper;

        const breakpointChecker = function () {
            // if larger viewport and multi-row layout needed
            if (breakpoint.matches === true) {
                // clean up old instances and inline styles when available
                if (mySwiper !== undefined) mySwiper.destroy(true, true);

                // or/and do nothing
                return;

                // else if a small viewport and single column layout needed
            } else if (breakpoint.matches === false) {
                // fire small viewport version of swiper
                return enableSwiper();
            }
        };

        const enableSwiper = function () {
            mySwiper = new Swiper(".js-presilicon-bnrcards", {
                loop: false,
                slidesPerView: 1.3,
                // a11y: true,
                keyboardControl: true,
                grabCursor: true,

                // pagination
                pagination: ".swiper-pagination",
                paginationClickable: true,
            });
        };

        // keep an eye on viewport size changes
        breakpoint.addListener(breakpointChecker);

        // kickstart
        breakpointChecker();
    })(); /* IIFE end */


})

// new side sticky

